import { createAxiosInstance } from '@/plugins/axios.plugin';
import axiosPlataformaClient from '../../plugins/axios.plataforma.plugin';
import queryString from 'query-string';
import { validateQueryParameters } from '~/helpers/verifyQueryParameters';

export class GroupSet {
  static SERVICE_NAME = 'groupset';

  constructor() {
    this.client = createAxiosInstance({
      baseURL        : process.env.PLATAFORMA_API,
      useAccessToken : true
    });
  }

  getAll({ limit, offset, filter, sortBy, order, mainId, isActive, paginated = true, getGroups }) {
    let url = `academic/groupset?mainId=${mainId || ''}`;
    if (paginated) {
      url += `&limit=${limit || 10}&offset=${offset || 0}&isActive=${isActive || ''}&filter=${filter || ''}&sortBy=${sortBy || ''}&order=${order || ''}`;
    } else {
      url += `&paginated=false&getGroups=${getGroups || ''}`;
    }

    return this.client.get(url);
  }

  create(payload) {
    return this.client.post('academic/groupset', payload);
  }

  edit({ id, ...payload }) {
    return this.client.put(`academic/groupset/${id}`, payload);
  }

  getById(id) {
    return this.client.get(`academic/groupset/${id}`);
  }

  delete(id) {
    return this.client.delete(`academic/groupset/${id}`);
  }

  getGroupsOfSet(id) {
    return this.client.get(`academic/groupset/${id}/groups`);
  }

  getAvailableParticipants({ mainId, groupSetId, searchName, page, perPage }) {
    return this.client.get(`academic/groupset/${groupSetId}/available-participants`, { params: { mainId, searchName, page, perPage } });
  }

  createGroup({ name, isActive, groupSetId }) {
    return this.client.post(`academic/groupset/${groupSetId}/groups`, {
      name,
      isActive
    });
  }

  editGroup({ id, name, isActive, groupSetId }) {
    return this.client.put(`academic/groupset/${groupSetId}/groups/${id}`, {
      name,
      isActive
    });
  }

  getAllByContentId(contentId) {
    return this.client.get(`content/main-content/${contentId}/groupset`);
  }

  getParticipants({ academicMainId, groupSetId, page, itemsPerPage, search, hasGroup, mainGroupId, sortDirection, orderBy }) {
    let stringified = queryString.stringify({ search, mainGroupId, sortDirection, sortBy: orderBy, hasGroup }, { skipNull: true, skipEmptyString: true });

    stringified = stringified.replace('hasGroup&', '');

    return axiosPlataformaClient.custAxios().get(`academic/academics-main/${academicMainId}/group-sets/${groupSetId}/participants?page=${page}&perPage=${itemsPerPage}&${stringified}`);
  }

  getGroupsByParticipantsCount({ academicMainId, groupSetId, countParticipants }) {
    return axiosPlataformaClient.custAxios().get(`academic/academics-main/${academicMainId}/group-sets/${groupSetId}/groups?selectedMembers=${countParticipants}`);
  }

  moveParticipantsBetweenGroups({ groupId, groupChangeConfiguration, enrollmentIds, groupSetId, courseId }) {
    const body = {
      groupId,
      groupChangeConfiguration,
      enrollmentIds
    };

    return axiosPlataformaClient.custAxios().post(`academic/academics-main/${courseId}/group-sets/${groupSetId}/participants`, body);
  }

  getAllParticipantsByMainGroupId({ groupsetId, courseId, hasGroup, search, mainGroupId, sortBy, sortDirection }) {
    const queryParams = validateQueryParameters({ hasGroup, search, mainGroupId, sortBy, sortDirection });

    return axiosPlataformaClient.custAxios().get(`academic/academics-main/${courseId}/group-sets/${groupsetId}/all-participants?${queryParams}`);
  }
};

export default new GroupSet();